export enum DateTypeInputMaskAliasMap {
	Integer = 'integerWithoutAutoGroup',
	Long = 'integerWithoutAutoGroup',
	BigDecimal = 'decimal',
	Currency = 'currency',
	Percentage = 'percentage',
}
